// extracted by mini-css-extract-plugin
export default {"productGallery":"tJ-z","inQuickShop":"uJ-z"};